import SectionLabel from "../components/shared/SectionLabel";
import MediumCard from "../components/shared/MediumCard";

const Writing = () => {
  return (
    <div className="fade-up">
      <SectionLabel>writing</SectionLabel>
      <h1 className="text-3xl lg:text-4xl font-bold">Notes & articles.</h1>
      <p className="text-muted mt-4 max-w-md">
        I write about backend engineering, systems, and things I run into
        while building. All of it lives on Medium.
      </p>

      <div className="mt-10">
        <MediumCard />
      </div>
    </div>
  );
};

export default Writing;
